"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-function-type */
(function (global) {
    // Capture document
    const document = global.document;
    // Capture object
    const Object = global.Object;
    // Capture array
    const Array = global.Array;
    // Capture console
    const console = global.console;
    const random = global.Math.random;
    // List of registered defines
    const loadedDefines = getPrototypeLessObject();
    // All loaded modules
    const executedDefines = getPrototypeLessObject();
    executedDefines.require = executedDefines.exports = executedDefines.module = null;
    // The pending modules, represented by deferred promises
    const waitingForNetworkDefines = getPrototypeLessObject();
    // Cache of already-fetched urls
    const downloadedUrls = getPrototypeLessObject();
    // Local requires cache
    const localRequires = getPrototypeLessObject();
    // Local exports cache
    const exports = getPrototypeLessObject();
    // Cached requireConfig information
    const moduleIdsToUrls = getPrototypeLessObject();
    // Map of modules for which to enforce define
    const enforceDefine = getPrototypeLessObject();
    // Map of modules for which to enforce define
    const loadedByUrl = getPrototypeLessObject();
    // Cached requireConfig metadata
    const metaDependenciesToUrl = getPrototypeLessObject();
    // Cached federated module require config
    const federatedModulePromiseCache = getPrototypeLessObject();
    // Domain fallback chain
    const fallbackDomains = getPrototypeLessObject();
    // List of path fallbacks
    const fallbacks = getPrototypeLessObject();
    // Map of modules and their dependencies
    const dependencyMap = getPrototypeLessObject();
    // Create a map of modules to direct dependencies
    const moduleIdsToImmediateChildren = getPrototypeLessObject();
    // Map of modules and their metadependencies
    const metaDependencies = getPrototypeLessObject();
    // Hashset of shims
    const shims = getPrototypeLessObject();
    // There's a secret rule where if you depend on a shim, your entire tree (from that point on) can depend on the shim.
    const addShimsToMyChildren = getPrototypeLessObject();
    // Maps needed to handle requireConfig.map
    const moduleAliases = getPrototypeLessObject();
    let mappedModuleAliasesArray = [];
    let mappedModules = getPrototypeLessObject();
    // Map of moduleIds to their "directory" (Root/Dir/Id => Root/Dir/)
    const moduleIdToDirectory = getPrototypeLessObject();
    // Hashet of generated ids for manual require([]) calls
    const manualRequires = getPrototypeLessObject();
    // Map of script downloads to their sequence of retries, where some retries are due to timeouts.
    // This is to anticipate cases where more than one retry completes in the background, leading to duplicate module defines.
    const urlDownloadStates = getPrototypeLessObject();
    // Domains to avoid for ajax calls
    const blockedOrigins = new Set();
    // Domains that have been logged for timeout and skip logging due to retrying. This can prevent excessive logging and avoid false-positive alerts.
    const loggedTimedOutOrigins = new Set();
    // Are we in a web worker context
    const inWebWorker = typeof global.importScripts === "function";
    // Capture promise
    const Promise = global.Promise;
    // Id used for anonymous modules
    const anonymousModuleId = "_preorder_anonymous_define_";
    // Id used for extra shim modules
    const preorderShimSuffix = "-preorder-shim";
    // Regex used in module id normalization; catches "foo/../" | "/./" | "./"
    const normalizationRegex = /[^/]+\/\.\.\/|\/\.(\/)|^\.\//;
    // Regex used to determine if a url ends with .js
    const isJsRegex = /\.js(?:[?#]|$)/;
    // Used to identify module ids that are already URLs
    const jsExtRegExp = /^\/|:|\?|\.js$/;
    // Regex used to detect a data or blob url
    const isDataOrBlobRegex = /^data:|^blob:/;
    // Regex used to detect a relative or http or https url
    const startsWithSlashOrHttpRegex = /^\/|^https?:/;
    // Regex used to detect a retryAttempt url
    const containsRetryAttemptRegex = /[&?]retryAttempt=/;
    // Regex used to catch groups separated by slashes
    const slashGroupRegex = /(.+\/)/;
    // Status code used for internal timeout
    const internalTimeoutCode = 408;
    // How long to wait in milliseconds for a request before timing out
    const internalTimeoutThreshold = 30000;
    // Noop function
    const noop = () => { };
    // Queue of scripts to inject in the document
    const scriptQueue = !inWebWorker && (() => {
        const nextTicker = Promise.resolve();
        let scheduled = null;
        let queue = document.createDocumentFragment();
        function appendToDocument() {
            if (queue.childNodes.length) {
                document.head.appendChild(queue);
                queue = document.createDocumentFragment();
                scheduled = null;
            }
        }
        return {
            appendChild: (script) => {
                queue.appendChild(script);
                scheduled = scheduled || nextTicker.then(appendToDocument);
            },
            appendToDocument: () => {
                if (!window.MsPortalFx || !window.MsPortalFx.isFeatureEnabled || window.MsPortalFx.isFeatureEnabled("pretick")) {
                    appendToDocument();
                }
            },
        };
    })();
    // Base url provided by config
    let baseUrl = "/";
    // Unique id used in require calls
    let requireCount = 0;
    // Preload behavior to work around Chrome h2 throttling, provided by config
    let preload = false;
    // Debug - profile flag
    let profile = "";
    // Debug - console log dependency loads
    let profileLogger = noop;
    // Debug - use performance markers with full call stacks
    let performanceMark = noop;
    // Telemetry - track module loads
    let onDependencyStateChange = noop;
    // If moduleId matches the pattern defined in the getRedirectModuleId function will return the new resolved moduleId
    let getRedirectModuleId = (moduleId, _parentModuleId) => moduleId;
    // Config-provided onNodeCreated
    let onNodeCreated;
    // Config-provided onMetadependenciesLoaded
    let onMetadependenciesLoaded;
    // Reports when a bundle download has completed
    let onBundleLoad;
    // Allows customization of module resolution
    let onResolveModule;
    // Config-provided logError
    const logError = (moduleId, error, warn, skipLogging) => {
        if (skipLogging) {
            return;
        }
        logPreorderError(moduleId, error, warn);
    };
    let logPreorderError = (moduleId, error, warn) => {
        warn ? console.warn(error) : console.error(error);
    };
    // Config-provided externalPreorderConfig
    let externalPreorderConfig;
    let externalPreorderConfigSortedKeys = [];
    // Reference to specified config in configure call
    let requireConfig;
    /**
     * IE endsWith polyfill
     */
    function endsWith(val, token) {
        return (val && token) && val.endsWith(token);
    }
    /**
     * Get a prototype-less object to iterate on for maps
     */
    function getPrototypeLessObject() {
        return Object.create(null);
    }
    /**
     * Get an object's own properties
     *
     * @param map StringMap to get keys from
     */
    function getMapEntries(map) {
        return map ? Object.keys(map) : [];
    }
    /**
     * Add a JavaScript extension to a url
     *
     * @param url Url
     */
    function makeJsUrl(url) {
        return url + ((isJsRegex.test(url) || isDataOrBlobRegex.test(url)) ? "" : ".js");
    }
    /**
     * Gets all immediate dependencies of a given module id
     *
     * @param moduleId Module id
     * @returns Dependencies
     */
    function getImmediateModuleIdDependencies(moduleId) {
        return [].concat(...getModuleIdVariants(moduleId).map(variant => moduleIdsToImmediateChildren[variant] || []));
    }
    /**
     * Gets all /lib/index variants of a module id
     *
     * @param moduleId Module id
     * @returns All variants including original module id
     */
    function getModuleIdVariants(moduleId) {
        const tryIndexedModuleIds = [moduleId];
        if (endsWith(moduleId, "/index")) {
            tryIndexedModuleIds.push(moduleId.substring(0, moduleId.length - 6));
        }
        else {
            tryIndexedModuleIds.push(moduleId + "/index");
            !endsWith(moduleId, "/lib") && tryIndexedModuleIds.push(moduleId + "/lib/index");
        }
        return tryIndexedModuleIds;
    }
    /**
     * Lookup url for module id
     *
     * @param moduleId Module id to get url for
     * @param skipJs Skip appending .js (when called from outside preorder)
     * @param urlDictionary Which url map to use
     */
    function toUrl(moduleId, skipJs, urlDictionary, localBaseUrl = baseUrl) {
        let moduleUrl = urlDictionary[moduleId];
        if (!moduleUrl) {
            const tryIndexedModuleIds = getModuleIdVariants(moduleId);
            for (const tryIndexedModuleId of tryIndexedModuleIds) {
                moduleUrl = urlDictionary[tryIndexedModuleId];
                if (moduleUrl) {
                    moduleIdToDirectory[moduleId] = tryIndexedModuleId.substring(0, tryIndexedModuleId.lastIndexOf("/") + 1);
                    break;
                }
            }
        }
        if (!moduleUrl) {
            if (jsExtRegExp.test(moduleId)) {
                // moduleId is already a URL
                moduleUrl = moduleId;
                // Don't enforceDefine if we're loading by module URL
                loadedByUrl[moduleId] = true;
            }
            else {
                // "Subpath" of moduleId can match path, to which we add remainder of path
                let moduleIdSuffix = "";
                moduleId.split("/").reduce((prev, chunk) => {
                    // Remember that "MsPortalImpl/Services//Services.IntuneZipFileHelper" is a thing
                    const fragment = (prev && chunk && (prev + "/") || prev) + chunk;
                    moduleUrl && (moduleIdSuffix += chunk && ("/" + chunk));
                    if (urlDictionary[fragment]) {
                        moduleUrl = urlDictionary[fragment];
                        moduleIdSuffix = "";
                    }
                    return fragment;
                }, "");
                // By spec, http://requirejs.org/docs/api.html#usage
                // If we have a partial match, use end of module id to complete path (appends empty string if not)
                // If not found, return baseUrl + moduleId
                // Since we used any part of the moduleId, append .js (except if called from outside preorder)
                moduleUrl = (((moduleUrl || "") + moduleIdSuffix) || ((moduleId.startsWith("/") || /^[\w+.-]+:/.test(moduleId) ? "" : localBaseUrl) + moduleId)) + (skipJs ? "" : ".js");
            }
            moduleUrl = tryApplyDomainFallbacks(moduleUrl);
        }
        else {
            // Report we found the moduleId's absolute url in our config, for enforceDefine reasons
            enforceDefine[moduleId] = true;
            const isJsOrDataOrBlob = isJsRegex.test(moduleUrl) || isDataOrBlobRegex.test(moduleUrl);
            // If found absolute path doesn't end with .js and isn't data|blob and
            // doesn't contain "?" (/^data\:|^blob\:|\?/, require-2.3.7.js:1752), append .js
            const extension = skipJs || isJsOrDataOrBlob || moduleUrl.includes("?") ? "" : ".js";
            // If ends with .js || starts with / || has protocol, treat as absolute path
            // Else, treat as relative path, return baseUrl + moduleUrl
            moduleUrl = (isJsOrDataOrBlob || startsWithSlashOrHttpRegex.test(moduleUrl) ? "" : localBaseUrl) + moduleUrl + extension;
        }
        // Module federation remote URL support. Remote URLs can be in the format alias@https://domain/remoteEntry.js
        if (moduleUrl.includes("@https://")) {
            const parts = moduleUrl.split("@https://");
            moduleUrl = tryApplyDomainFallbacks("https://" + parts[1]);
        }
        return moduleUrl;
    }
    /**
     * Resolve anonymous define
     *
     * @param moduleId Name to register anonymous module under
     */
    function resolveAnonymousDefine(moduleId, src, resolveShim) {
        if (!loadedDefines[moduleId]) {
            if (loadedDefines[anonymousModuleId]) {
                registerDefine(moduleId, [], anonymousModuleId);
            }
            else if (!resolveShim) {
                retryOrFail(moduleId, src, null, `Module "${moduleId}" wasn't defined explicitly or anonymously in downloaded file "${src}"; trying fallback path.`);
            }
        }
        resolveShim && resolveShim();
    }
    /**
     * Internal use only - isolate try {} catch {} in its own function to avoid optimization bailout
     *
     * @param fn Function to run
     * @param onError Error handler
     */
    function tryCatch(fn, onError) {
        try {
            fn();
        }
        catch (error) {
            let stringified = "(Unserializable)";
            try {
                stringified = JSON.stringify(error, (key, value) => value instanceof Error ? {
                    message: value.message,
                    stack: value.stack,
                } : value);
            }
            catch (e) {
                // continue regardless of error
            }
            onError(stringified);
        }
    }
    /**
     * Inject javascript to DOM, either via url or content
     *
     * @param moduleId Id of the injected module
     * @param src Script url
     * @param resolveShim Callback to execute after script execution (used for shims resolution)
     */
    function injectScript(moduleId, src, resolveShim, alreadyHttpCached = false) {
        !alreadyHttpCached && onBundleLoad?.(src, true);
        const downloadState = urlDownloadStates[moduleId];
        if (!inWebWorker) {
            const node = document.createElement("script");
            node.setAttribute("data-requiremodule", moduleId);
            node.async = true;
            node.src = src;
            node.crossOrigin = "anonymous";
            const timedOutRetry = setTimeout(() => {
                if (downloadState.successfulUrl) {
                    // No need to retry here, if another retry already succeeded.
                    return;
                }
                retryOrFail(moduleId, node.src, resolveShim, `define for "${moduleId}" wasn't called because of a script timeout for "{${src}}", trying Ajax call.`, { warn: 1 /* LogType.Warning */, status: internalTimeoutCode });
            }, internalTimeoutThreshold);
            // Retry logic
            node.onerror = (error) => {
                clearTimeout(timedOutRetry);
                if (downloadState.successfulUrl) {
                    // No need to retry here, if another retry already succeeded.
                    return;
                }
                const errorSrc = error?.target && `[${error.target.src}]` || `{${src}}`;
                retryOrFail(moduleId, node.src, resolveShim, `define for "${moduleId}" wasn't called because of a script error for "${errorSrc}", trying Ajax call.`, { warn: 1 /* LogType.Warning */ });
            };
            // Anonymous define resolution
            node.onload = () => {
                // Report that one of the retries succeeded.
                downloadState.successfulUrl = src;
                !alreadyHttpCached && onBundleLoad?.(src, false);
                clearTimeout(timedOutRetry);
                resolveAnonymousDefine(moduleId, src, resolveShim);
            };
            // Calling onNodeCreated after all properties on the node have been set, but before it is placed in the DOM
            onNodeCreated && onNodeCreated(node, requireConfig, moduleId, src);
            // Chrome can throttle h2 JavaScript network requests with "low" priority to behave like h1 requests (6 connections/domain limit);
            // adding a <link rel="preload"> element promotes the network priority to "high" and restores true h2 behavior
            if (preload) {
                const link = document.createElement("link");
                link.rel = "preload";
                link.as = "script";
                link.href = node.src;
                link.crossOrigin = "anonymous";
                scriptQueue.appendChild(link);
            }
            // Queue scripts in a document fragment
            scriptQueue.appendChild(node);
        }
        else {
            // Note: Web workers do not use script tags for downloading, so, they don't need to anticipate zombie retries (using urlDownloadStates).
            // Network error handling has already happened in the ajax load; handle only JavaScript errors below
            tryCatch(() => {
                global.importScripts(src);
                resolveAnonymousDefine(moduleId, src, resolveShim);
                downloadState.successfulUrl = src;
            }, (error) => {
                // Throw the exception to bubble up to telemetry, retry if possible
                retryOrFail(moduleId, src, resolveShim, `self.importscripts failed for "${moduleId}" at "${src}" with error ${error}, retrying.`, { warn: 1 /* LogType.Warning */ });
            });
        }
    }
    /**
     * Error callback for module load failure
     *
     * @param moduleId Module id
     * @param message String explaining the error
     * @param data Optional data to attach to the error for diagnostic purposes
     */
    function failModule(moduleId, message, data = {}) {
        if (!(moduleId in executedDefines)) {
            const error = new Error(message);
            error.data = { moduleId, ...data };
            !data.skipLogging && logError(moduleId, error, 0 /* LogType.Error */);
            resolveModule(moduleId, null, error);
        }
    }
    /**
     * Fetch logic, stubbing data: and blob: fetch
     *
     * @param url Url to fetch
     * @returns Promise resolved when fetch returns or times out
     */
    function preorderFetch(url) {
        if (url && (url.startsWith("data:") || url.startsWith("blob:"))) {
            // Microsoft Edge/IE do not support fetch of data: and blob: uris, so resolve with HTTP 200 OK
            return Promise.resolve({ status: 200 });
        }
        else {
            return Promise.race([
                global.fetch(url).then(response => ({
                    status: response.status,
                    message: () => response.text(),
                })),
                new Promise(resolve => {
                    setTimeout(() => resolve({
                        status: internalTimeoutCode,
                        message: () => Promise.resolve("Internal timeout"),
                    }), internalTimeoutThreshold);
                }),
            ]);
        }
    }
    /**
     * Get the origin for a given url
     *
     * @param moduleUrl Url to parse the hostname from
     * @returns Url's origin
     */
    function getOrigin(moduleUrl) {
        return moduleUrl && new URL(moduleUrl).origin;
    }
    /**
     * Adds a query parameter to bust the cache for the given URL.
     *
     * @param moduleUrl Url to set cache busting query for
     * @returns Url with the cache busting query appended
     */
    function addCacheBustQuery(moduleUrl) {
        return !containsRetryAttemptRegex.test(moduleUrl) && moduleUrl + `${moduleUrl.includes("?") ? "&" : "?"}retryAttempt=${1 + random()}`;
    }
    function tryApplyDomainFallbacks(moduleUrl) {
        if (!URL.canParse(moduleUrl)) {
            return moduleUrl;
        }
        const moduleOrigin = getOrigin(moduleUrl);
        if (!blockedOrigins.has(moduleOrigin)) {
            return moduleUrl;
        }
        let nextOrigin = fallbackDomains[moduleOrigin];
        while (blockedOrigins.has(nextOrigin) && nextOrigin !== moduleOrigin) {
            nextOrigin = fallbackDomains[nextOrigin];
        }
        return moduleUrl.replace(moduleOrigin, nextOrigin || moduleOrigin);
    }
    /**
     * Get legacy path fallback for a failed network request
     *
     * @param moduleUrl Url to get a fallback path for
     */
    function getLegacyPathFallback(moduleUrl) {
        const fallback = (fallbacks[moduleUrl] || []).shift();
        if (fallback) {
            fallbacks[fallback] = fallbacks[moduleUrl];
        }
        return fallback || moduleUrl;
    }
    /**
     * Get path fallback for a failed network request
     *
     * @param moduleUrl Url to get a fallback path for
     */
    function applyFallbackModifiers(moduleId, currentModuleUrl) {
        const moduleUrl = getLegacyPathFallback(currentModuleUrl);
        const originalOrigin = getOrigin(moduleUrl);
        const downloadState = urlDownloadStates[moduleId];
        let nextOrigin = fallbackDomains[originalOrigin];
        // if there's no next origin, return for last attempt on same domain
        // if a different moduleUrl was spit out of legacy pathway, we return it for an extra attempt
        if (!nextOrigin) {
            return moduleUrl === currentModuleUrl ? addCacheBustQuery(moduleUrl) : moduleUrl;
        }
        // Ideally, we won't use an origin that's globally blocked and one that has already been attempted
        while (nextOrigin !== originalOrigin && nextOrigin) {
            const blocked = blockedOrigins.has(nextOrigin);
            const alreadyTried = downloadState.attemptedOrigins.has(nextOrigin);
            if (!blocked && !alreadyTried) {
                return moduleUrl.replace(originalOrigin, nextOrigin);
            }
            nextOrigin = fallbackDomains[nextOrigin];
        }
        nextOrigin = fallbackDomains[nextOrigin];
        // Second best, ignore the global block, but make it the last try
        while (nextOrigin !== originalOrigin && nextOrigin) {
            if (!downloadState.attemptedOrigins.has(nextOrigin)) {
                return addCacheBustQuery(moduleUrl.replace(originalOrigin, nextOrigin));
            }
            nextOrigin = fallbackDomains[nextOrigin];
        }
        // we've tried everything, no fallbacks left
        return;
    }
    /**
     * Set legacy fallback paths for a given path
     *
     * @param moduleUrl Path to set fallback paths for
     * @param fallbacks Fallback paths
     */
    function setLegacyPathFallbacks(moduleUrl, moduleUrlFallbacks) {
        fallbacks[makeJsUrl(moduleUrl)] = moduleUrlFallbacks.map(makeJsUrl);
    }
    /**
     * Retry handler for ajax load
     *
     * @param moduleId Id of the module to load
     * @param moduleUrl Url of the file containing module to load
     * @param resolveShim Callback to execute on successful script load (used for shim resolution)
     * @param errorMessage Reason we're retrying
     */
    function retryOrFail(moduleId, moduleUrl, resolveShim, errorMessage, options = {}) {
        const isTimeout = options.status === internalTimeoutCode;
        const origin = getOrigin(moduleUrl);
        const skipLogging = isTimeout && loggedTimedOutOrigins.has(origin);
        if (isTimeout) {
            loggedTimedOutOrigins.add(origin);
            blockedOrigins.add(origin);
        }
        const fallback = applyFallbackModifiers(moduleId, moduleUrl);
        const fallbackOrigin = getOrigin(fallback);
        if (fallback && !containsRetryAttemptRegex.test(moduleUrl)) {
            urlDownloadStates[moduleId].attemptedOrigins.add(fallbackOrigin);
            // For last retry, delay retrying if user is offline or the portal is backgrounded
            if (containsRetryAttemptRegex.test(fallback)) {
                if (document.visibilityState === "hidden") {
                    const handleVisibilityChange = () => {
                        if (document.visibilityState === "visible") {
                            global.removeEventListener("visibilitychange", handleVisibilityChange);
                            loadScript(moduleId, fallback, resolveShim, /* isRetry = */ true);
                        }
                    };
                    global.addEventListener("visibilitychange", handleVisibilityChange);
                    return;
                }
                if (!global.navigator.onLine) {
                    const handleNetworkChange = () => {
                        global.removeEventListener("online", handleNetworkChange);
                        loadScript(moduleId, fallback, resolveShim, /* isRetry = */ true);
                    };
                    global.addEventListener("online", handleNetworkChange);
                    return;
                }
            }
            loadScript(moduleId, fallback, resolveShim, /* isRetry = */ true);
        }
        else {
            failModule(moduleId, errorMessage, { ...options, skipLogging });
        }
    }
    /**
     * Try to httpRequest a script and inject it once cached
     *
     * @param moduleId Id of the module to load
     * @param moduleUrl Url of the file containing module to load
     * @param resolveShim Callback to execute on successful script load (used for shim resolution)
     */
    function tryAjaxLoad(moduleId, moduleUrl, resolveShim) {
        onBundleLoad?.(moduleUrl, true);
        preorderFetch(moduleUrl).then(response => {
            if (response.status === 200) {
                onBundleLoad?.(moduleUrl, false);
                // Script is now httpcached, inject src = moduleUrl
                injectScript(moduleId, moduleUrl, resolveShim, true);
            }
            else {
                retryOrFail(moduleId, moduleUrl, resolveShim, `Couldn't load "${moduleId}"; error code ${response.status}`, { status: response.status, moduleUrl });
            }
        }, (error) => {
            // When the promise from window.fetch rejected it is equivalent to when XmlHttpRequest fails with a status code of 0.
            // This is usually when a network error occurred and the server never received the request.
            // The actual error returned from the rejected fetch promise is never useful. It is always localized string like 'Failed to fetch'.
            // In addition to being localized different browsers return different strings making the reporting and detection in tooling
            // challenging if not impossible.  We do retain the error in the data portion of the error should we need to exam it for diagnostic
            // purposes.
            // Hardcoding to 0 also gives us consistency in our error reporting with ajax failure errors.
            retryOrFail(moduleId, moduleUrl, resolveShim, `Couldn't load "${moduleId}"; Failed to fetch; error code 0`, { status: 0, moduleUrl, error });
        });
    }
    /**
     * Cache promise representing a pending module
     *
     * @param moduleId Pending module id
     * @param pluginErrorHandler Error handler to attach on promise for plugins
     */
    function setPendingModule(moduleId, pluginErrorHandler) {
        performanceMark(moduleId);
        if (!(waitingForNetworkDefines[moduleId])) {
            let _resolve;
            let _reject;
            waitingForNetworkDefines[moduleId] = {
                preorderPromise: new Promise((resolve, reject) => {
                    _resolve = resolve;
                    pluginErrorHandler && (_resolve.error = pluginErrorHandler);
                    _reject = (reason) => {
                        reason = reason || "[Unknown error]";
                        waitingForNetworkDefines[moduleId].rejected = reason;
                        reject(reason);
                    };
                }),
                resolve: _resolve,
                reject: _reject,
            };
        }
        return waitingForNetworkDefines[moduleId];
    }
    /**
     * Cache module definition result
     *
     * @param moduleId Resulting module's id
     * @param module Resulting module
     * @param error Error to reject a pending module's promise with
     */
    function resolveModule(moduleId, module, error) {
        performanceMark(moduleId, true);
        onDependencyStateChange(moduleId, 1 /* DependencyLoadState.Finish */);
        !error && (executedDefines[moduleId] = module);
        const modulePromise = waitingForNetworkDefines[moduleId];
        modulePromise && (error ? modulePromise.reject(error) : modulePromise.resolve(module));
    }
    /**
     * Extract plugin id from a module id
     *
     * @param moduleId Module id to extract plugin id from, e.g. "pluginId!moduleId"
     * @returns Plugin id
     */
    function extractPluginId(moduleId) {
        const plingIndex = moduleId.indexOf("!");
        if (plingIndex > -1) {
            return moduleId.slice(0, plingIndex);
        }
    }
    /**
     * Context-agnostic script loader
     *
     * @param moduleId Id of the module to load
     * @param moduleUrl Url of the file containing module to load
     * @param resolveShim Callback to execute on successful script load (used for shim resolution)
     * @param isRetry If this is a retry attempt
     */
    function loadScript(moduleId, moduleUrl, resolveShim, isRetry) {
        // We resort to ajax load in WebWorker context because
        // A) importScripts can stop its synchronous, ordered execution for a JavaScript exception OR network error;
        //    ajax loading separates those and allows us to try to recover from network issues
        // B) importScripts executes scripts in order, meaning n's JavaScript execution is waiting on n-1's network request
        // Additionally, we resort to ajax load when retrying because we get more descriptive information about network errors.
        urlDownloadStates[moduleId] ??= { attemptedOrigins: new Set([getOrigin(moduleUrl)]) };
        (isRetry || inWebWorker ? tryAjaxLoad : injectScript)(moduleId, moduleUrl, resolveShim);
    }
    /**
     * Load a module
     *
     * @param parentId Id of the parent module needing the loaded module
     * @param moduleId Id of module to load
     * @param shim If the module to load is a shim
     * @returns Module if already loaded, promise if not
     */
    function load(parentId, moduleId, shim) {
        // If moduleId matches the pattern defined in the getRedirectModuleId function will update the moduleId
        moduleId = getAliasMapping(getRedirectModuleId((moduleId), parentId));
        onDependencyStateChange(moduleId, 0 /* DependencyLoadState.Start */, parentId);
        // If we're already executed or already network-pending, return module or pending promise
        // Note that we will loop through all aliases for moduleId and return the module or pending promise for the first match. This avoids a second download of the same bundle based on a different alias.
        for (const moduleIdCandidate of getModuleNameAliases(moduleId, true)) {
            // If we're not executed but already downloaded, execute
            if (!(moduleIdCandidate in executedDefines || waitingForNetworkDefines[moduleIdCandidate]) && loadedDefines[moduleIdCandidate]) {
                // Executing will set either executedDefines or waitingForNetworkDefines, which we re-check in the next if
                executeDefine(moduleIdCandidate, loadedDefines[moduleIdCandidate][0], loadedDefines[moduleIdCandidate][1]);
                // If we don't run this, either return exisiting module/promise or download and return promise
            }
            // If we're already executed or already network-pending, return module or pending promise
            if (moduleIdCandidate in executedDefines || waitingForNetworkDefines[moduleIdCandidate]) {
                return (moduleIdCandidate in executedDefines) ? executedDefines[moduleIdCandidate] : waitingForNetworkDefines[moduleIdCandidate];
            }
        }
        // Handle plugin route
        const pluginId = extractPluginId(moduleId);
        if (pluginId) {
            if (pluginId in executedDefines || waitingForNetworkDefines[pluginId]) {
                const promise = setPendingModule(moduleId, (error) => logError(moduleId, "Plugin loading error : " + error));
                const pluginDependency = moduleId.slice(pluginId.length + 1);
                if (pluginId in executedDefines) {
                    executedDefines[pluginId].load(pluginDependency, generateLocalRequire(parentId), waitingForNetworkDefines[moduleId].resolve, requireConfig);
                }
                else {
                    waitingForNetworkDefines[pluginId].preorderPromise.then((plugin) => plugin.load(pluginDependency, generateLocalRequire(parentId), waitingForNetworkDefines[moduleId].resolve, requireConfig));
                }
                return promise;
            }
            else {
                logError(moduleId, `Module "${moduleId}", needed by "${parentId}", needs plugin "${pluginId}" which is not defined nor pending at this point.  Attempting to load as normal module.`, 1 /* LogType.Warning */);
            }
        }
        // Fetch metadependencies
        injectMetaDependencies(moduleId);
        const moduleUrl = toUrl(moduleId, false, moduleIdsToUrls);
        // If our bundle has not been downloaded before...
        if (!downloadedUrls[moduleUrl]) {
            downloadedUrls[moduleUrl] = true;
            profileLogger(() => `Downloading "${moduleUrl}" for "${moduleId}" needed by "${(parentId.substring(0, parentId.indexOf(" Error")) || parentId)}".`);
            if (shim) {
                const shimDependencies = mapDependencies(moduleId);
                // Prefetch shim while its dependencies load, avoiding a shim waterfall
                const shimPrefetch = shimDependencies.length && preorderFetch(moduleUrl);
                const loadShim = () => {
                    // InjectScript here using a -preorder-shim-content id
                    loadScript(moduleId + preorderShimSuffix + "-content", moduleUrl, () => {
                        // Resolve actual module id afterwards;
                        // Will noop if shim wasn't an actual shim but a named define
                        // Anonymous define scenario taken care of with loadedDefine check
                        const anonymousDefine = loadedDefines[moduleId + preorderShimSuffix + "-content"] || [[], null];
                        executeDefine(moduleId, anonymousDefine[0], anonymousDefine[1]);
                    });
                };
                // Wait for shim dependencies using a -preorder-shim-dependencies id
                executeDefine(moduleId + preorderShimSuffix + "-dependencies", shimDependencies, () => {
                    // Inject the shim after prefetch settles
                    shimPrefetch ? shimPrefetch.then(loadShim, loadShim) : loadShim();
                });
            }
            else {
                // To quote require-2.3.7.js's BEGIN MODIFIED BY IBIZA :
                // We want enforceDefine for modules that are part of bundles generated by the Ibiza framework. This avoids
                // issues such as null-refs when network glitches result in an empty response with status 200.
                const dontEnforceDefine = !enforceDefine[moduleId] && (() => {
                    if (!loadedDefines[moduleId]) {
                        if (!loadedByUrl[moduleId]) {
                            logError(moduleId, `Module "${moduleId}" wasn't defined explicitly or anonymously in downloaded file "${moduleUrl}".  Will proceed assuming it loaded correctly.`);
                        }
                        registerDefine(moduleId, [], null);
                    }
                });
                loadScript(moduleId, moduleUrl, dontEnforceDefine);
            }
        }
        return setPendingModule(moduleId);
    }
    /**
     * Normalize a dependency's module id with respect to defined module's id
     *
     * @param moduleId Defined module's id
     * @param dependency Dependency module's id
     */
    function normalize(moduleId, dependency) {
        if (!dependency) {
            return moduleId;
        }
        if (dependency.startsWith(".")) {
            dependency = (moduleIdToDirectory[moduleId] || (moduleIdToDirectory[moduleId] = (slashGroupRegex.exec(moduleId) || [""])[0])) + dependency;
        }
        if (~dependency.indexOf("./") || ~dependency.indexOf("/.")) {
            while (normalizationRegex.test(dependency)) {
                dependency = dependency.replace(normalizationRegex, "$1");
            }
        }
        return dependency;
    }
    /**
     * Generate a local require relative to specified parent module
     *
     * @param parentModule Parent module to base localRequire on
     */
    function generateLocalRequire(parentModule) {
        if (localRequires[parentModule]) {
            return localRequires[parentModule];
        }
        const localNormalize = (moduleId) => normalize(parentModule, moduleId);
        const localToUrl = (id) => toUrl(id, true, moduleIdsToUrls);
        const localRequire = (configOrDependenciesOrDependency, dependenciesOrCallback, callbackOrErrback, errbackOrNothing) => {
            if (typeof configOrDependenciesOrDependency === "string") {
                // The function is bound against an object which has "normalize" and "toUrl"
                configOrDependenciesOrDependency = getAliasMapping(localNormalize(configOrDependenciesOrDependency));
                if (configOrDependenciesOrDependency in executedDefines) {
                    return executedDefines[configOrDependenciesOrDependency];
                }
                else {
                    logAndThrow(configOrDependenciesOrDependency, `Uncaught Error: Module name "${configOrDependenciesOrDependency}" has not been loaded yet. Use require([]).`);
                }
            }
            const moduleId = "require " + requireCount++;
            manualRequires[moduleId] = true;
            let defineArguments;
            if (!Array.isArray(configOrDependenciesOrDependency)) {
                configure(configOrDependenciesOrDependency);
                if (Array.isArray(dependenciesOrCallback)) {
                    defineArguments = [moduleId, dependenciesOrCallback, callbackOrErrback];
                }
                else {
                    defineArguments = [moduleId, [], dependenciesOrCallback];
                }
            }
            else {
                defineArguments = [moduleId, configOrDependenciesOrDependency, dependenciesOrCallback];
            }
            let dependencies = defineArguments[1];
            if (dependencies) {
                // Normalize dependencies according to localRequire
                dependencies = dependencies.map(localNormalize);
                // Append known dependencies
                defineArguments[1] = dependencies.concat(...dependencies.map(moduleId => mapDependencies(moduleId) || []));
                profileLogger(() => "Manually requiring " + JSON.stringify(dependencies) + " which has the following known dependencies " + JSON.stringify(defineArguments[1]));
            }
            // Instrumentation
            // Note: This can potentially add plug-in uses from the dependencies into the moduleId itself and confuse the plug-in logic.  Disabled for now.
            // profile && (defineArguments[0] += JSON.stringify(defineArguments[1]) + " " + (new Error().stack));
            // eslint-disable-next-line prefer-spread
            executeDefine.apply(null, defineArguments);
            waitingForNetworkDefines[moduleId] && waitingForNetworkDefines[moduleId].preorderPromise.then(null, errbackOrNothing || callbackOrErrback);
            // Flush currently traversed list of scripts
            scriptQueue && scriptQueue.appendToDocument();
            // By spec
            return localRequires[moduleId];
        };
        localRequire.normalize = localNormalize;
        localRequire.toUrl = localToUrl;
        // Signal this is the new require
        localRequire.isPreorder = true;
        return localRequires[parentModule] = localRequire;
    }
    /**
     * Determine if a module is a shim or a derives from one
     *
     * @param moduleId Module id to check
     */
    function isShim(moduleId) {
        // Covers all require.config-flagged shims...
        let isShim = shims[moduleId];
        if (isShim === undefined) {
            // ... and memoized results of this call
            isShim = shims[moduleId] = !!~moduleId.indexOf("**Shim") || !!~moduleId.indexOf(preorderShimSuffix);
        }
        return isShim;
    }
    /**
     * Load a module dependency
     *
     * @param parentModule Module owning the dependency
     * @param dependencies List of dependent module ids
     */
    function loadDependencies(parentModule, dependencies) {
        // There's a secret rule where if you depend on a shim, your entire tree (from that point on) depends on the shim.
        const shimsToAdd = !isShim(parentModule) && addShimsToMyChildren[parentModule];
        shimsToAdd && (dependencies = dependencies.concat(getMapEntries(shimsToAdd)));
        profileLogger(() => `Loading dependencies for "${(parentModule.substring(0, parentModule.indexOf(" Error")) || parentModule)}", which are ${JSON.stringify(dependencies)}`);
        const loadedDependenciesOrPromises = new Array(dependencies.length);
        // Loop through dependencies in reverse order, downloading / executing leaves first
        for (let i = dependencies.length - 1; i >= 0; --i) {
            const dependency = dependencies[i];
            if (dependency === "require") {
                loadedDependenciesOrPromises[i] = generateLocalRequire(parentModule);
            }
            else if (dependency === "exports") {
                loadedDependenciesOrPromises[i] = exports[parentModule] = { _exportsDefinedId: parentModule };
            }
            else if (dependency === "module") {
                loadedDependenciesOrPromises[i] = { id: parentModule };
            }
            else if (isShim(dependency)) {
                dependencies.forEach(child => (addShimsToMyChildren[child] || (addShimsToMyChildren[child] = getPrototypeLessObject()))[dependency] = true);
                loadedDependenciesOrPromises[i] = load(parentModule, dependency, true);
            }
            else {
                loadedDependenciesOrPromises[i] = load(parentModule, dependency);
            }
        }
        return loadedDependenciesOrPromises;
    }
    /**
     * Compute mapped version of a module id
     *
     * @param moduleId Module id to map
     */
    function computeAliasMapping(moduleId) {
        return mappedModuleAliasesArray.reduce((prev, alias) => {
            return prev.startsWith(alias[0] + "/") || prev === alias[0] ? prev.replace(alias[0], alias[1]) : prev;
        }, moduleId);
    }
    /**
     * Get mapped version of a module id
     *
     * @param moduleId Module id to map
     */
    function getAliasMapping(moduleId) {
        let mappedModuleId = mappedModules[moduleId];
        if (!mappedModuleId) {
            mappedModuleId = mappedModules[moduleId] = computeAliasMapping(moduleId);
        }
        return mappedModuleId;
    }
    /**
     * Normalize arguments passed in to [moduleId, dependencies, moduleDefinition]
     *
     * @param moduleId ModuleId or dependencies or moduleDefinition
     * @param dependencies Dependencies or moduleDefinition or null
     * @param moduleDefinition ModuleDefinition or null
     * @param fromRegisterDefine If we should skip adding known dependencies and module normalization (needed for anonymous defines, which we can only normalize once we know their id)
     * @param script The current script.
     */
    function normalizeArguments(firstArgument, secondArgument, thirdArgument, fromRegisterDefine, script) {
        let moduleId = firstArgument;
        let dependencies = secondArgument;
        let moduleDefinition = thirdArgument;
        // If we're not bundled, first argument is not going to be our module id, we have no id;
        // use anonymousModuleId, which will be "dequeued" after script execution
        if (typeof moduleId !== "string") {
            moduleDefinition = dependencies;
            dependencies = moduleId;
            moduleId = script?.getAttribute("data-requiremodule") ?? anonymousModuleId;
        }
        // So apparently, we're not forced to have dependencies and can skip straight to moduleDefinition.
        if (!Array.isArray(dependencies)) {
            moduleDefinition = dependencies;
            dependencies = [];
        }
        // Add known dependencies to specified ones (redundant ones will just be the same promises/objects)
        const knownDeps = !fromRegisterDefine && mapDependencies(moduleId);
        if (knownDeps) {
            dependencies = dependencies ? dependencies.concat(knownDeps) : knownDeps;
        }
        // define("a", (require, exports, module) => { }) is something requirejs allows
        if (!dependencies || !dependencies.length) {
            dependencies = ["require", "exports", "module"];
        }
        // Add plugin if needed
        const pluginId = extractPluginId(moduleId);
        if (pluginId) {
            dependencies = dependencies ? dependencies.concat(pluginId) : [pluginId];
        }
        const aliasedModuleId = !fromRegisterDefine ? getAliasMapping(moduleId) : moduleId;
        // Normalize dependencies
        if (dependencies && !fromRegisterDefine) {
            dependencies = dependencies.reduce((prev, dependency) => {
                const normalizedDependency = normalize(moduleId, dependency);
                const aliasedDependency = getAliasMapping(normalizedDependency);
                if (aliasedDependency === normalizedDependency || aliasedDependency !== aliasedModuleId) {
                    prev.push(aliasedDependency);
                }
                return prev;
            }, []);
        }
        return [aliasedModuleId, dependencies || [], moduleDefinition];
    }
    /**
     * Define a module
     * Will be called by any script invoking global define() to define a module.
     *
     * @param moduleId Id of module to define
     * @param dependencies Ids of module dependencies
     * @param moduleDefinition Module definition function
     */
    function registerDefine(moduleId, dependencies, moduleDefinition) {
        [moduleId, dependencies, moduleDefinition] = normalizeArguments(moduleId, dependencies, moduleDefinition, true, document?.currentScript);
        // Multiple defines of same file
        if (loadedDefines[moduleId]) {
            // If one of the script download retries has succeeded, then this must be a zombie retry that completed in the background, so, it can be ignored.
            // const currentSrc = (document.currentScript as HTMLScriptElement)?.src;
            // if (!urlDownloadStates[currentSrc]?.loadSuccessful) {
            //     logError(moduleId, "Tried to redefine " + moduleId, LogType.Warning);
            // }
            return;
        }
        loadedDefines[moduleId] = [dependencies, moduleDefinition];
        // Handle anonymous define resolution
        if (moduleDefinition === anonymousModuleId) {
            loadedDefines[moduleId] = [dependencies, moduleDefinition] = loadedDefines[anonymousModuleId];
            loadedDefines[anonymousModuleId] = null;
        }
        for (const moduleWithoutIndex of getModuleNameAliases(moduleId, false)) {
            const fixedDependencies = dependencies.map(d => normalize(moduleId, d));
            waitingForNetworkDefines[moduleWithoutIndex] && executeDefine(moduleWithoutIndex, fixedDependencies, moduleDefinition);
            loadedDefines[moduleWithoutIndex] = [fixedDependencies, moduleDefinition];
        }
        waitingForNetworkDefines[moduleId] && executeDefine(moduleId, dependencies, moduleDefinition);
    }
    function getModuleNameAliases(moduleId, includeSelf) {
        const result = [];
        includeSelf && result.push(moduleId);
        for (const suffix of ["/index", "/lib/index"]) {
            if (endsWith(moduleId, suffix)) {
                const moduleWithoutIndex = moduleId.substring(0, moduleId.length - suffix.length);
                !moduleIdsToUrls[moduleWithoutIndex] && result.push(moduleWithoutIndex);
            }
        }
        return result;
    }
    /**
     * Try to immediately run module definition callback if all dependencies are loaded, else wait on those
     *
     * @param moduleId Id of the module to define
     * @param dependencies List of module dependencies
     * @param promisesOrModules Result of loadDependencies on aforementioned module dependencies
     * @param callback Module definition callback
     * @param dependencyErrorCallback Error callback in case a dependency fails to load
     */
    function tryImmediateResolve(moduleId, dependencies, promisesOrModules, callback, dependencyErrorCallback) {
        // If all promises are not promises, execute callback (there's no such thing as a resolved promise possible here, because when resolved, loadDependencies returns the module)
        if (!promisesOrModules ||
            !promisesOrModules.length ||
            !promisesOrModules.some(p => p && p.preorderPromise && p.preorderPromise.then)) {
            callback(promisesOrModules);
        }
        else {
            // Else, Promise.all on them
            Promise.all(promisesOrModules.map(p => p && p.preorderPromise && p.preorderPromise.then && p.preorderPromise || p)).then(callback, dependencyErrorCallback);
        }
    }
    /**
     * Execute a module definition
     *
     * @param moduleId Id of module to define
     * @param dependencies Ids of module dependencies
     * @param moduleDefinition Module definition function
     */
    function executeDefine(moduleId, dependencies, moduleDefinition) {
        [moduleId, dependencies, moduleDefinition] = normalizeArguments(moduleId, dependencies, moduleDefinition);
        // Multiple defines of same file
        if (moduleId in executedDefines) {
            logError(moduleId, "Tried to re-execute module definition of " + moduleId, 1 /* LogType.Warning */);
            return;
        }
        // Set pending module
        setPendingModule(moduleId);
        const resolve = () => {
            tryImmediateResolve(moduleId, dependencies, loadDependencies(moduleId, dependencies), (dependentModules) => {
                if (moduleDefinition && typeof moduleDefinition !== "function") {
                    resolveModule(moduleId, moduleDefinition);
                }
                else {
                    tryCatch(
                    // Two things can happen; A they return something and never touch exports, B they set properties on export and expect that to be the module.
                    () => {
                        const invokeDefinitionAndResolveModule = () => {
                            const moduleExport = exports[moduleId];
                            // The portal framework alters the behavior of defineProperty for reasons related to the proxying of knockout objects (PO layer)
                            // This however interferes with the export of submodules in some cases.
                            // We change defineProperty back to the native browser implemention when we invoke the module define,
                            // then restore back to the altered framework behavior after the define completes population the exports.
                            const fxDefineProperty = Object.defineProperty;
                            let moduleDefinitionResult = undefined;
                            try {
                                Object.defineProperty = (window.MsPortalFx && MsPortalFx.defineProperty) || Object.defineProperty;
                                moduleDefinitionResult = moduleDefinition && moduleDefinition.apply(moduleExport, dependentModules);
                            }
                            finally {
                                Object.defineProperty = fxDefineProperty;
                            }
                            resolveModule(moduleId, moduleDefinitionResult || moduleExport);
                        };
                        onResolveModule ? onResolveModule(moduleId, invokeDefinitionAndResolveModule) : invokeDefinitionAndResolveModule();
                    }, error => failModule(moduleId, `Couldn't load "${moduleId}" at "${toUrl(moduleId, false, moduleIdsToUrls)}" as the following exception was thrown; ${error}`));
                }
            }, (_error) => {
                const failedDependencies = dependencies.filter(d => waitingForNetworkDefines[d] && waitingForNetworkDefines[d].rejected);
                const failurePrefix = manualRequires[moduleId] ?
                    "Manual require of the following modules failed" :
                    `Couldn't load "${moduleId}" at "${toUrl(moduleId, false, moduleIdsToUrls)}" as the following dependencies failed to load`;
                // first status is a the status of the first depedency
                // typically there is only one failed module
                let firstStatus;
                const failedModules = failedDependencies.map((failedModule) => {
                    const moduleError = waitingForNetworkDefines[failedModule].rejected;
                    const { data: { status, moduleUrl } } = moduleError;
                    const { message } = moduleError;
                    firstStatus = firstStatus === undefined ? status : firstStatus;
                    return {
                        name: failedModule,
                        moduleUrl,
                        message,
                        status,
                    };
                });
                // Just the failing dependency names, the rest is on error.data.failedModules.
                // Interpolating .rejected here cascades: nested failures each already contain
                // their own "[dep : {Error: ...}]" dumps.
                const failedNames = failedDependencies.map(d => `"${d}"`).join(", ");
                const codeSuffix = firstStatus === undefined ? "" : `; error code ${firstStatus}`;
                failModule(moduleId, `${failurePrefix}; [${failedNames}]${codeSuffix}; see error.data.failedModules for per-dependency detail`, { status: firstStatus, failedModules });
            });
        };
        const cachePreorderConfigPromise = (federatedModuleId) => {
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            if (federatedModulePromiseCache[federatedModuleId]) {
                return federatedModulePromiseCache[federatedModuleId];
            }
            const promise = externalPreorderConfig[federatedModuleId]().then((externalConfig) => {
                if (externalConfig) {
                    configure(externalConfig);
                }
                else {
                    delete federatedModulePromiseCache[federatedModuleId];
                }
            });
            federatedModulePromiseCache[federatedModuleId] = promise;
            return promise;
        };
        // Check if attempting to load a parent module with a federated module as a dependency. If so,
        // cache the promise to get its require config and wait for it to resolve before resolving the parent module.
        // eslint-disable-next-line unicorn/prefer-spread
        const federatedModulesToLoad = Array.from(new Set(dependencies
            .map((moduleId) => externalPreorderConfigSortedKeys.find((modulePrefix) => moduleId.startsWith(modulePrefix)))
            .filter(Boolean)));
        const preorderConfigPromises = federatedModulesToLoad.map(cachePreorderConfigPromise);
        if (preorderConfigPromises.length) {
            Promise.all(preorderConfigPromises).then(() => resolve());
        }
        else {
            resolve();
        }
    }
    /**
     * Recursively add dependencies for each module
     *
     * @param moduleId Id of the module to check
     */
    function mapDependencies(moduleId) {
        moduleId = getAliasMapping(moduleId);
        let dependencies = dependencyMap[moduleId];
        if (!dependencies) {
            dependencies = dependencyMap[moduleId] = [];
            for (const dependency of getImmediateModuleIdDependencies(moduleId)) {
                dependencies.push(dependency);
                mapDependencies(dependency).forEach(dependency => dependencies.push(dependency));
            }
            // Dependencies are later downloaded in reverse order, and leaves must be downloaded first thus be at the end of this array;
            // [a,b,c,d,b,c] must become [a,d,b,c] which is achievable if unique keys are collected with reduceRight then the result is reversed;
            // [a, b, c, d, b, c] => [c, b, d, c, b, a] => [c, b, d, a] => [a, d, b, c]
            dependencies = dependencyMap[moduleId] = getMapEntries(dependencies.reduceRight((unique, id) => unique[id] = unique, getPrototypeLessObject())).reverse().filter(dependency => dependency !== moduleId);
        }
        return dependencies;
    }
    /**
     * Configure requirejs using provided configuration
     *
     * @param config Provided configuration
     */
    function configure(config) {
        // Cache config & assign it to "_" context for backcompat
        requireConfig = require.s.contexts._.config = config;
        // Add urls for every path
        for (const moduleOrBundleId of getMapEntries(config.paths)) {
            if (Array.isArray(config.paths[moduleOrBundleId])) {
                const urls = config.paths[moduleOrBundleId];
                moduleIdsToUrls[moduleOrBundleId] = urls[0];
                // Add legacy fallbacks
                urls.length > 1 && setLegacyPathFallbacks(urls[0], urls.slice(1));
            }
            else {
                moduleIdsToUrls[moduleOrBundleId] = config.paths[moduleOrBundleId];
            }
        }
        // Add urls for every module in every bundle
        for (const bundleId of getMapEntries(config.bundles)) {
            for (const moduleId of config.bundles[bundleId]) {
                let urls = ((config.paths || {})[bundleId] || []);
                if (!Array.isArray(urls)) {
                    urls = [urls];
                }
                moduleIdsToUrls[moduleId] = urls[0];
                // Add legacy fallbacks
                urls.length > 1 && setLegacyPathFallbacks(urls[0], urls.slice(1));
            }
        }
        // Add shims
        for (const moduleOrBundleId of getMapEntries(config.shim)) {
            for (const moduleId of [moduleOrBundleId].concat(config.bundles && config.bundles[moduleOrBundleId] || [])) {
                // If you have "deps", you're a shim
                // eslint-disable-next-line no-constant-binary-expression -- shims[moduleOrBundleId] = true is suspicious, but doesn't seem to be a bug considering length of time in use on live portal
                const shimDeps = config.shim[moduleOrBundleId] ? Array.isArray(config.shim[moduleOrBundleId]) ? config.shim[moduleOrBundleId] : config.shim[(shims[moduleOrBundleId] = true) && moduleOrBundleId].deps : [];
                shimDeps.forEach(moduleId => shims[moduleId] = true);
                moduleIdsToImmediateChildren[moduleId] = shimDeps;
            }
        }
        // Add dependencyTree
        const dependencyTree = config.dependencyTree;
        for (const url of getMapEntries(dependencyTree)) {
            for (const moduleId of getMapEntries(dependencyTree[url])) {
                // Flatten module & immediate children
                moduleIdsToImmediateChildren[moduleId] = (moduleIdsToImmediateChildren[moduleId] || []).concat(dependencyTree[url][moduleId]);
                // Add urls for every module
                moduleIdsToUrls[moduleId] = url;
            }
        }
        // Handle map
        let changesMappings = false;
        for (const targettedModule of getMapEntries(config.map)) {
            if (targettedModule === "*") {
                const configAliasMap = config.map[targettedModule];
                for (const alias of getMapEntries(configAliasMap)) {
                    const newTarget = configAliasMap[alias];
                    if (moduleAliases[alias] !== newTarget) {
                        // Add aliases to existing aliases using a map for uniqueness
                        moduleAliases[alias] = newTarget;
                        changesMappings = true;
                    }
                }
            }
            else {
                logError(targettedModule, `This module loader only support property "*" in requireConfig.map, execution will continue without considering property "${targettedModule}".`, 1 /* LogType.Warning */);
            }
        }
        if (changesMappings) {
            // Invalidate cache of module mappings
            mappedModules = getPrototypeLessObject();
            // Update the array of unique aliases
            // Sort aliases by big-length-first so that mappedModuleAliasesArray.reduce wont prevent the following scenario :
            // require.config({"map":{"*":{ "a/b": "a", "a/b/c": "a" }}})(["a/b/c"]);
            mappedModuleAliasesArray = getMapEntries(moduleAliases)
                .map(alias => [alias, moduleAliases[alias]])
                .sort((a, b) => b[0].length - a[0].length);
        }
        // Add legacy fallbacks (primary user previously was baseDomains behavior, now deprecated in favor of fallback domains)
        for (const moduleUrl of getMapEntries(config.fallbacks)) {
            setLegacyPathFallbacks(moduleUrl, config.fallbacks[moduleUrl]);
        }
        // Use performance markers
        profile = profile || config.profile;
        if (profile) {
            profileLogger = (message) => console.log("[Preorder] [" + profile + "] " + message());
            const performance = global.performance;
            if (performance) {
                performanceMark = ((moduleId, measure) => {
                    performance.mark(moduleId + (measure ? "-stop" : ""));
                    measure && performance.measure(moduleId, moduleId, moduleId + "-stop");
                });
            }
        }
        // Set preload behavior
        preload = preload || config.preload;
        // Set reactview perf telemetry function
        if (config.onDependencyStateChange) {
            onDependencyStateChange = config.onDependencyStateChange;
        }
        // Set get redirect module Id function
        if (config.getRedirectModuleId) {
            getRedirectModuleId = config.getRedirectModuleId;
        }
        // Set error logger
        config.logError && (logPreorderError = config.logError);
        // Set external preorder config
        if (config.externalPreorderConfig) {
            externalPreorderConfig = { ...externalPreorderConfig, ...config.externalPreorderConfig };
            externalPreorderConfigSortedKeys = Object.keys(externalPreorderConfig).sort((a, b) => a.length - b.length);
        }
        // Merge in fallback domains
        if (config.fallbackDomains) {
            Object.keys(config.fallbackDomains).forEach((i) => fallbackDomains[i] = config.fallbackDomains[i]);
        }
        // Set onNodeCreated
        config.onNodeCreated && (onNodeCreated = config.onNodeCreated);
        // Set onMetadependenciesLoaded
        config.onMetadependenciesLoaded && (onMetadependenciesLoaded = config.onMetadependenciesLoaded);
        // Set baseUrl
        config.baseUrl && (baseUrl = config.baseUrl.endsWith("/") ? config.baseUrl : (config.baseUrl || "") + "/");
        // Download dependencies
        config.deps && config.deps.forEach(dep => executeDefine("_preorder_dep_" + dep, [dep].concat(dependencyMap[dep] || []), null));
        // Flush currently traversed list of scripts
        scriptQueue && scriptQueue.appendToDocument();
        // Set onBundleLoad
        if (config.onBundleLoad) {
            onBundleLoad = config.onBundleLoad;
        }
        // Set onResolveModule
        if (config.onResolveModule) {
            onResolveModule = config.onResolveModule;
        }
        // By spec
        return global.requirejs;
    }
    /**
     * Configure requirejs metadependencies using provided metadapendency map and requireConfig
     *
     * @param metaDependencyMap Provided metadependency map
     * @param config Provided configuration, unaccessible except through injectMetaDependencies
     */
    function configureMetadata(metaDependencyMap, config) {
        for (const moduleId of getMapEntries(metaDependencyMap)) {
            // Enable reuse of configureMetadata with the same ids to runtime-inject metadependencies;
            // This allows us to say "I'm about to download contextMenuV2 and I'll need bladeLauncher"
            // but only in scenarios where that's actually true.
            metaDependencies[moduleId] = metaDependencies[moduleId] || [];
            for (const dependency of metaDependencyMap[moduleId] || []) {
                metaDependencies[moduleId].push(dependency);
            }
        }
        const dependencyTree = config && config.dependencyTree;
        for (const url of getMapEntries(dependencyTree)) {
            for (const module of getMapEntries(dependencyTree[url])) {
                metaDependenciesToUrl[module] = url;
            }
        }
    }
    /**
     * Log an error message and throw it, exists because throwing in a webworker importScript won't surface the exception
     *
     * @param moduleId Id of the module concerned by the error
     * @param error What to log & throw
     */
    function logAndThrow(moduleId, error) {
        logError(moduleId, error);
        throw error;
    }
    /**
     * Recursively initiate script injection for metadependencies
     *
     * @param moduleId Module id to inject dependencies for
     */
    function injectMetaDependencies(moduleId) {
        if (!(moduleId in metaDependencies)) {
            return;
        }
        const moduleMetaDependencies = new Set();
        const mapMetaDependencies = (moduleId) => {
            if (!moduleMetaDependencies.has(moduleId)) {
                moduleMetaDependencies.add(moduleId);
                for (const dependency of getImmediateModuleIdDependencies(moduleId)) {
                    mapMetaDependencies(dependency);
                }
            }
        };
        metaDependencies[moduleId].forEach(dependency => mapMetaDependencies(dependency));
        const loadMetadependencyPromises = [];
        const urlNotFound = "URL_NOT_FOUND";
        moduleMetaDependencies.forEach(dependency => {
            const dependencyUrl = toUrl(dependency, false, metaDependenciesToUrl, urlNotFound);
            if (!dependencyUrl.includes(urlNotFound) && !downloadedUrls[dependencyUrl]) {
                downloadedUrls[dependencyUrl] = true;
                profileLogger(() => `Downloading "${dependencyUrl}" for "${dependency}" needed by fetchMetaDependency for "${moduleId}".`);
                let resolveMetadependency;
                onMetadependenciesLoaded && loadMetadependencyPromises.push(new Promise(res => resolveMetadependency = res));
                loadScript(dependency, dependencyUrl, resolveMetadependency);
            }
        });
        onMetadependenciesLoaded && onMetadependenciesLoaded(moduleId, Promise.all(loadMetadependencyPromises));
    }
    // Set global variables
    global.nodeRequire = global.require;
    const globalRequire = global.require = global.requirejs = generateLocalRequire(null);
    globalRequire.config = configure;
    global.define = registerDefine;
    // Contract requires this to be an object (true wouldn't match spec)
    global.define.amd = getPrototypeLessObject();
    // Add new prefetcher config
    globalRequire.configureMetadata = configureMetadata;
    // Backcompat
    globalRequire.s = { contexts: { _: { config: null } } };
    // Report
    globalRequire.loadedDefines = loadedDefines;
    globalRequire.executedDefines = executedDefines;
    globalRequire.unrequire = (moduleId, deep) => {
        delete executedDefines[moduleId];
        delete waitingForNetworkDefines[moduleId];
        if (deep) {
            delete loadedDefines[moduleId];
            const moduleUrl = toUrl(moduleId, false, moduleIdsToUrls);
            delete downloadedUrls[moduleUrl];
            delete urlDownloadStates[moduleId];
        }
    };
    globalRequire.mapDependencies = mapDependencies;
}(window || self));
/* eslint-enable @typescript-eslint/no-unsafe-function-type */
//# sourceMappingURL=preorder.js.map